import { Navigate, Outlet } from "react-router-dom";
import { usePermissions } from "@/hooks/usePermissions";

export default function RequireAdmin() {
  const perms = usePermissions();
  if (!perms.loaded) return null;
  if (!perms.isAdmin) return <Navigate to="/" replace />;
  return <Outlet />;
}
